import RequestInterceptor from '@nibfe/request-interceptor';
import SessionCore from './session';
import Config from '../config';

export default class Interceptor {
	/**
	 * 请求拦截
	 * 请求发起前获取请求 url，将 url 域名信息进行记录
	 */
	static intercept (): void {
		RequestInterceptor.request.use(
			(config: any): any => {
				if (!config.url) return config;
				// 获取请求 url domain
				const domainReg: RegExp = /^(https?:)?\/\/([0-9a-zA-Z][\w-.]+)/;
				const path = window.location && window.location.pathname;
				let domain: string = '';
				let regRes = domainReg.exec(config.url);
				if (regRes && regRes[2]) {
					domain = regRes[2];
				}
				// 以当前域相对路径发起请求，设置域名为当前域
				if (!domain) domain = window.location && window.location.hostname;
				// 黑名单中不包含 domain 且当前记录中 apiDomains 不包含当前 domain
				// 则在当前记录中 apiDomains 内写入 domain
				if (!Config.domainBlackList.includes(domain)) {
					const currentStackInfo: Record<string, any> = SessionCore.getCurrentStackInfo(path);
					const apiDomains: string[] = currentStackInfo.apiDomains || [];
					if (!apiDomains.includes(domain)) apiDomains.push(domain);
					SessionCore.refreshCurrentStackInfo(path, Object.assign(currentStackInfo, { apiDomains }));
				}
				return config;
			},
			(err: Error): Promise<never> => {
				return Promise.reject(err);
			}
		)
	}
}
